var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessAdvisory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "url(#paint0_linear_161_118)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 38.75C30.1906 38.7497 32.561 37.9327 34.4834 36.429L40.5279 42.4735L42.4721 40.5293L36.4276 34.4847C37.9321 32.5621 38.7496 30.1913 38.75 27.75C38.75 21.6849 33.8151 16.75 27.75 16.75C21.6849 16.75 16.75 21.6849 16.75 27.75C16.75 33.8151 21.6849 38.75 27.75 38.75ZM27.75 19.5C32.2999 19.5 36 23.2001 36 27.75C36 32.2999 32.2999 36 27.75 36C23.2001 36 19.5 32.2999 19.5 27.75C19.5 23.2001 23.2001 19.5 27.75 19.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_161_118",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3896BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4558"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessAdvisory);
export default __webpack_public_path__ + "static/media/BusinessAdvisory.32e7ee81bb7afe8e0dbdc01043eb4d0c.svg";
export { ForwardRef as ReactComponent };